import React from 'react';
import styles from './styles.css';
import sharedStyles from '../../styles/shared.css';
import StationPropType from '../../utils/prop-types/station';

const { getStationBrand } = require('../../../lib/bputils').default;

const StationWithAddress = ({ station }) => (
  <div>
    <div className={styles.stationLogoWrapper}>
      <img
        src={getStationBrand(station.brandings).brand_logo}
        alt=""
        className={styles.stationLogo}
      />
    </div>
    <div className={sharedStyles.pullLeft}>
      <div className={styles.stationName}>{`${station.retailer_name} - #${station.retailer_reference}`}</div>
      <div className={styles.address}>{`${station.address.address} ${station.address.city}, ${station.address.state}, ${station.address.zip}`}</div>
    </div>
    <div className="clearfix" />
  </div>
);

StationWithAddress.propTypes = {
  station: StationPropType.isRequired,
};

export default StationWithAddress;
